import axios from 'axios';
import { Capacitor } from '@capacitor/core';
import { translate } from '../i18n';

// On the web, the React app and Express server are same-origin in production
// (and CRA proxies /api to localhost:5000 in dev), so a relative /api works.
// On native (Capacitor), the WebView is loaded from capacitor://localhost,
// so we must hit the live API at an absolute URL.
const API_BASE =
  process.env.REACT_APP_API_BASE
  || (Capacitor.isNativePlatform() ? 'https://invio.my/api' : '/api');

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use(cfg => {
  const token = localStorage.getItem('token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

api.interceptors.response.use(
  r => r,
  err => {
    // Server errors carry a stable `code`; swap the English message for the
    // user's language when we have a translation (server.<code> in the locales).
    const code = err.response?.data?.code;
    if (code) {
      const localized = translate(`server.${code}`);
      if (localized !== `server.${code}`) err.response.data.message = localized;
    }
    if (err.response?.status === 401) {
      // Expired impersonation token → drop back to the admin session
      const adminToken = localStorage.getItem('adminToken');
      if (adminToken) {
        localStorage.setItem('token', adminToken);
        localStorage.removeItem('adminToken');
        window.location.href = '/admin/users';
      } else {
        localStorage.removeItem('token');
        window.location.href = '/login';
      }
    }
    // 402 = subscription/trial (incl. grace period) has lapsed — send user to the pay page
    if (err.response?.status === 402 && window.location.pathname !== '/subscription') {
      window.location.href = '/subscription';
    }
    return Promise.reject(err);
  }
);

export default api;
